import * as React from 'react';
import { SearchResults } from '../model/searchresultModel';

interface TabsModel {
    result: SearchResults,
    activeTab: number,
    onChange: (e: number) => void;
}

const Tabs: React.FC<TabsModel> = (props) => {

    const active = 'border-b-[5px] border-orange-secondary py-3 has-[a:hover]:border-black has-[a:active]:border-b-2 transition-all duration-300 shrink-0';
    const deactive = 'border-b border-orange-secondary py-3 has-[a:hover]:border-black has-[a:hover]:border-b-[5px] has-[a:active]:border-b-2 transition-all duration-300 shrink-0';

    return (
        <>
            <div className="relative">
                <ul className="flex flex-row flex-nowrap overflow-x-scroll gap-4 desktop:gap-6 items-stretch scrollbar-hidden scrollbar-fade-end pr-10">
                    <li className={props.activeTab === 1 ? active : deactive}>
                        <button onClick={() => props.onChange(1)} className="text-lg laptop:text-xl text-black-text focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-red-secondary">
                            Oppskrifter ({props.result.recipeSearchResult.totalMatching})
                        </button>
                    </li>

                    <li className={props.activeTab === 2 ? active : deactive}>
                        <button onClick={() => props.onChange(2)} className="text-lg laptop:text-xl text-black-text focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-red-secondary">
                            Artikler ({props.result.articleSearchResult.totalMatching})
                        </button>
                    </li>

                    <li className={props.activeTab === 3 ? active : deactive}>
                        <button onClick={() => props.onChange(3)} className="text-lg laptop:text-xl text-black-text focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-red-secondary">
                            Råvarer ({props.result.ingredientSearchResult.totalMatching})
                        </button>
                    </li> 
                </ul>
            </div>
            <div className="border-t border-orange-secondary mb-5 -mt-[1px]"></div>
        </>
    );
};

export default Tabs;
